import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, FormControl, Paper, useTheme } from '@mui/material';
import Alert from '@mui/material/Alert';
import { blue, green } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { CustomerOrderInfo, CustomerURLInformation } from 'adoms-common-lib';
import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from 'tss-react/mui';
import { CustomerURLInformationUtil } from '../../common/customerURLInformationUtil';
import ApplicationTooBar from '../../components/molecule/ApplicationToolBar';
import OrderDestinationInfo from '../../components/molecule/OrderDestinationInfo';
import OrderGoodsTable from '../../components/molecule/OrderGoodsTable';
import OrderStepBar, { Process } from '../../components/molecule/OrderStepBar';

const useStyles = makeStyles()((theme) => ({
    griditem: {
    },

    table: {
        minWidth: 100,
    },
    paper: {
        padding: '12px',
        textAlign: 'center',
        height: '100%',
    },
    confirmNum: {
        textAlign: 'center',
        height: '100%',
        width: '300px'
    },
    title: {
        flexGrow: 1,
        textAlign: 'center',
        backgroundColor: blue[500],
        color: 'white',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 32,
    },
    link: {
        textDecoration: 'none',
    }
}));




function createData(name: string, gram: number, count: number) {
    return { name, gram, count };
}


export default function CustomerOrderComplete() {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const order = location.state.order as CustomerOrderInfo;
    // URLIDコピーのためシャローコピー
    const customerURLInformation = { ...CustomerURLInformationUtil.instance.getCustomerURLInformation() };
    const theme = useTheme();

    useEffect(() => {
        if (customerURLInformation !== undefined) {
            CustomerURLInformationUtil.instance.deleteCustomerURLInformation();
        }
    });

    const handleNavigateTopPage = async () => {
        const urlId = customerURLInformation?.urlId;
        if (!urlId) {
            console.log("undefined urlId");
            navigate('/forbidden403Page');
            return;
        }
        await CustomerURLInformationUtil.instance.updateCustomerURLInformationByUrlId(urlId);
        navigate(`/${urlId}`);
    }

    const handleNavigateOrderViewPage = () => {
        if (!customerURLInformation?.tenantId) {
            navigate('/forbidden403Page');
            return;
        }
        navigate(`/requesterview?tenantid=${customerURLInformation.tenantId}&orderid=${order.orderID}`);
    };

    return (
        <div>
            <Grid container justifyContent="center" xs={12} spacing={1}>
                <Grid item xs={12} sm={12} >
                    <ApplicationTooBar label="配送依頼完了" />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <OrderStepBar process={Process.Complete} />

                    <Grid item xs={12}>
                        {/* Replaced Alert with centered Paper */}
                        <Box sx={{
                            fontSize: 48,
                            color: theme.palette.success.main
                        }}>
                            <Paper elevation={0} sx={{
                                backgroundColor: green[50],
                                border: `1px solid ${theme.palette.success.light}`,
                                textAlign: 'center',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                                <Grid container justifyContent="center">
                                    <Grid item xs={12} sx={{ mt: 2, mb: 1, px: 2 }}>
                                        <Typography sx={{ whiteSpace: 'pre-line' }}>
                                            以下の内容で配送依頼が完了しました。　確認番号をお控えのうえ配送物をドローンオペレーターにお渡しください。
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sx={{ mb: 2 }}>
                                        <Button variant='contained' onClick={handleNavigateOrderViewPage} sx={{ maxWidth: 300 }}>
                                            配送状況確認ページ
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <div>
                        <Typography className={classes.title} variant="h6" component="div">
                            確認番号
                        </Typography>
                        <Paper className={classes.paper} elevation={0}>
                            <Grid container justifyContent="center">
                                <Grid item xs={12} sm={12} className={classes.griditem}>
                                    <Typography variant="h5" component="div" color="secondary">
                                        {order.orderID}
                                        <div><QRCodeCanvas value={order.orderID} /></div>
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sm={2} className={classes.griditem}>
                                </Grid>
                                <Grid item xs={8} sm={8} className={classes.griditem}>
                                    <Alert severity="warning" style={{ textAlign: "center" }}>確認番号は配送時の受け取りに必要な番号です。QRコードを保存するか、必ずメモをお取りください</Alert>
                                </Grid>
                                <Grid item xs={2} sm={2} className={classes.griditem}>
                                </Grid>

                            </Grid>

                        </Paper>
                    </div>
                </Grid>
                {/* <Typography className={classes.title} variant="h6" component="div">
                外部注文情報
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        外部注文番号
                        <Typography variant="h5" component="div" color="secondary">
                            {order.externalOrderID !== undefined ? order.externalOrderID : "連携なし"}
                        </Typography>
                    </Paper>
                </Grid> */}
                <Typography className={classes.title} variant="h6" component="div">
                    配送希望時間
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        <Typography variant="h5" component="div" color="secondary">
                            {
                                order.preferredDeliveryDate !== '' &&
                                    order.preferredDeliveryTime !== '' ?
                                    `${order.preferredDeliveryDate} ${order.preferredDeliveryTime}` :
                                    "指定なし"
                            }
                        </Typography>
                    </Paper>
                </Grid>
                <Typography className={classes.title} variant="h6" component="div">
                    荷物の受取人
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <OrderDestinationInfo order={order} />
                </Grid>

                <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                    店舗担当者連絡先
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        <Typography variant="h5" component="div">
                            {order.requester.lastname} {order.requester.firstname}様
                        </Typography>
                        <Typography variant="body1" component="div">
                            電話番号：{order.destination.tel2}
                        </Typography>
                    </Paper>
                </Grid>
                <Typography className={classes.title} variant="h6" component="div">
                    発着ポート
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        {order.departure.name} ⇒ {order.arrival.name}
                    </Paper>
                </Grid>

                <Typography className={classes.title} variant="h6" component="div">
                    配送物
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <OrderGoodsTable order={order} />
                </Grid>

                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        <FormControl variant="standard" className={classes.formControl}>
                            <IconButton
                                edge="start"
                                color="primary"
                                aria-label="menu"
                                size="large"
                                onClick={() => handleNavigateTopPage()}
                            >
                                <HomeIcon /><Typography>ホームに戻る</Typography>
                            </IconButton>
                        </FormControl>
                    </Paper>
                </Grid>

            </Grid>
        </div >
    );
}